var map = {
	"./en/infoCollectAgree.ts": [
		7130,
		130
	],
	"./zh_CN/infoCollectAgree.ts": [
		6267,
		267
	],
	"./zh_HK/infoCollectAgree.ts": [
		8886,
		886
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1360;
module.exports = webpackAsyncContext;